<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      Thêm thanh toán
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col sm="6" xs="12">
              <div>
                <label for="datepicker-lg">Ngày tạo</label>
                <b-form-datepicker
                  :disabled="true"
                  id="datepicker-lg"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  }"
                  v-model="payment.date"
                  locale="vi"
                ></b-form-datepicker>
              </div>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input label="Số tiền cần thanh toán" :mask="'number'" v-model="amount" disabled="true"></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <ValidationProvider name="Tiền khách đưa" rules="required" v-slot="{ errors }">
                <base-input
                  label="Tiền khách đưa"
                  :mask="'number'"
                  :error="errors[0]"
                  v-model="amountCustomer"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input
                disabled="true"
                :label="amountCustomer - amount >= 0 ? `Tiền thừa` : `Còn thiếu`"
                :value="amountCustomer - amount"
                :mask="'number'"
              ></base-input>
            </b-col>

            <b-col sm="4" xs="12">
              <base-select
                label="Loại tiền"
                @change="changeCurrrency"
                v-model="payment.currency"
                :options="['VND', 'USD']"
              ></base-select>
            </b-col>
            <b-col sm="4" xs="12">
              <div>
                <label for="method_payment">Phương thức thanh toán</label>
                <select v-model="payment.method" id="method_payment" class="form-control">
                  <option value="0">Không rõ</option>
                  <option value="1">Chuyển khoản</option>
                  <option value="2">Tiền mặt</option>
                </select>
              </div>
            </b-col>
            <b-col sm="4" xs="12">
              <base-input label="Transaction ID" v-model="payment.transaction"></base-input>
            </b-col>
          </b-row>
        </form>
        <hr />
        <base-table thead-classes="thead-light" :data="receiptBill">
          <template slot="columns">
            <th>STT</th>
            <th class="text-left">Mã phiếu xuất</th>
            <th class="text-left">Ngày xuất</th>
            <th class="text-right">Tổng tiền</th>
            <th class="text-right">Tổng tiền sau thuế</th>
            <th class="text-right">Đã thanh toán</th>
            <th class="text-right">Còn lại</th>
          </template>

          <template slot-scope="{ row, index }">
            <tr>
              <td class="bg-info text-light col-fix ">
                {{ index + 1 }}
              </td>
              <td class="text-left">{{ row.code }}</td>
              <td class="text-left">{{ $dateUnix(row.dateCreated) }}</td>
              <td class="text-right">{{ $formatNumber(row.total) }} {{ row.currency }}</td>
              <td class="text-right">
                <span v-if="row.totalAmout"> {{ $formatNumber(row.totalAmout) }} {{ row.currency }} </span>
                <span v-else>
                  Không thuế
                </span>
              </td>
              <td class="text-right">{{ $formatNumber(row.paid) }} {{ row.currency }}</td>
              <td class="text-right">
                <span v-if="row.totalAmout"> {{ $formatNumber(row.totalAmout - row.paid) }} {{ row.currency }} </span>
                <span v-else> {{ $formatNumber(row.total - row.paid) }} {{ row.currency }} </span>
              </td>
            </tr>
          </template>
        </base-table>
        <div class="form-group" style="overflow: hidden;">
          <label class="form-control-label" for="">Ghi chú</label>
          <ckeditor :editor="editor" v-model="payment.note" @ready="onReady" :config="editorConfig"></ckeditor>
        </div>
        <b-row>
          <b-col sm="6" xs="12" md="4">
            <b-button class="mb-2" block variant="success" @click="doSave(1)">
              Lưu tiếp (Shift + F4)
            </b-button>
          </b-col>
          <b-col sm="6" xs="12" md="4">
            <b-button class="mb-2" type="submit" block variant="dark" @click="doSave(0)">
              Lưu đóng (F4)
            </b-button>
          </b-col>
          <b-col sm="12" md="4">
            <b-button class="mb-2" block variant="secondary" @click="handleClose">
              Đóng (Esc)
            </b-button>
          </b-col>
        </b-row>
      </ValidationObserver>
    </block>
    <event @doCancel="handleClose" @doSave="doSave(0)" @doSaveContinue="doSave(1)"></event>
  </modal>
</template>
<script>
import { receiptService } from '@/_services';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
  props: {},
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      visible: false,
      receiptBill: [],
      allReceiptBill: [],
      payment: {
        date: new Date(),
        amount: 0,
        method: 2,
        transaction: '',
        customer: '',
        note: '',
        currency: ''
      },
      amountCustomer: 0,
      amount: 0,
      ownInfo: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'link',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'indent',
          'outdent',
          'link',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells'
        ]
      }
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.payment.amount = this.amountCustomer <= this.amount ? this.amountCustomer : this.amount;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        let payment = Object.assign({}, self.payment);
        payment.customer.receiptBill = [];
        // let receiptBill = self.receiptBill.slice(); // copy array
        // receiptBill.forEach(element => {
        //   delete element.receiptBillDetails;
        // });
        receiptService
          .addPayment(payment, [])
          .then(res => {
            self.$emit('submit:success');

            if (type == 0) {
              self.visible = false;
            }
            self.payment = res.data.payment;
            self.receiptBill = res.data.receiptBill;
            this.$alertify.success(res.message, {
              duration: 4000
            });
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csInfo.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            this.$refs.bmdal.unBlock();
          });
      });
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    setData(item) {
      this.allReceiptBill = item.customer.receiptBill;
      this.amount = 0;
      this.receiptBill = [];
      this.payment.customer = item.customer;

      this.allReceiptBill.forEach(element => {
        if (!this.payment.currency || this.payment.currency == '') {
          this.payment.currency = element.currency;
        }
        if (this.payment.currency == element.currency) {
          //this.amount += element.total - element.paid;
          if (element.totalAmout > 0) {
            this.amount += element.totalAmout - element.paid;
          } else {
            this.amount += element.total - element.paid;
          }

          this.payment.currency = element.currency;
          this.receiptBill.push(element);
        }
      });
      this.amountCustomer = this.amount;
    },
    changeCurrrency() {
      this.amount = 0;
      this.receiptBill = [];
      this.allReceiptBill.forEach(element => {
        if (!this.payment.currency || this.payment.currency == '') {
          this.payment.currency = element.currency;
        }
        if (this.payment.currency == element.currency) {
          if (element.totalAmout > 0) {
            this.amount += element.totalAmout - element.paid;
          } else {
            this.amount += element.total - element.paid;
          }

          this.payment.currency = element.currency;
          this.receiptBill.push(element);
        }
      });
      this.amountCustomer = this.amount;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss"></style>
